import React, { useState } from 'react';
import { Form, Input, Select, InputNumber, Row, Col } from 'antd';
import { SectionHeader } from '../AirwayBillDetail';

const { Option } = Select;

const BasicInfoSection = ({ ports, customers, batches, form }) => {
  return (
    <Row gutter={4} align="top" style={{ marginBottom: '8px' }}>
      <Col span={2}>
        <SectionHeader>基本信息</SectionHeader>
      </Col>
      <Col span={22}>
        <Row gutter={4}>
          <Col span={6}>
            <Form.Item 
              name="airway_bill_number" 
              label="空运单号" 
              rules={[{ required: true, message: '请输入空运单号' }]}
            >
              <Input
                onChange={(e) => {
                  // Remove all spaces from the input value, including spaces between numbers
                  const value = e.target.value.replace(/\s+/g, '');
                  form.setFieldValue('airway_bill_number', value);
                }}
                onBlur={(e) => {
                  // Remove all spaces from the input value, including spaces between numbers
                  const value = e.target.value.replace(/\s+/g, '');
                  if (value) {
                    // Check format xxx-xxxxxxxx
                    const regex = /^[A-Za-z0-9]{3}-\d{8}$/;
                    const formatValid = regex.test(value);
                    
                    let isValid = false;
                    if (formatValid) {
                      // Get the 8 digits after hyphen
                      const numbers = value.split('-')[1];
                      // First 7 digits minus the 8th digit
                      const first7 = parseInt(numbers.substring(0, 7));
                      const last1 = parseInt(numbers.substring(7));
                      isValid = (first7 - last1) % 7 === 0;
                    }

                    e.target.style.backgroundColor = isValid ? 'white' : '#f6bead';
                    form.setFields([{
                      name: 'airway_bill_number',
                      value: value,
                      errors: isValid ? [] : ['空运单号格式不正确 (格式: XXX-XXXXXXXX，且后8位数字需满足(前7位-第8位)能被7整除)']
                    }]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              name="port_of_entry" 
              label="落地口岸" 
              rules={[{ required: true, message: '请选择落地口岸' }]}
            >
              <Select>
                {ports?.map(port => (
                  <Option key={port.port_id} value={port.port_id}>
                    {port.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="batch_ids" label="批次">
              <Select
                mode="multiple"
                showSearch
                placeholder="请选择批次"
                allowClear
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {batches?.map(batch => (
                  <Option key={batch.id} value={batch.id}>
                    {batch.batch_number}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              name="customer" 
              label="客户" 
              rules={[{ required: true, message: '请选择客户' }]}
            >
              <Select
                showSearch
                placeholder="请选择客户"
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {customers?.map(customer => (
                  <Option key={customer.id} value={customer.id}>
                    {customer.company_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={4}>
          <Col span={6}>
            <Form.Item name="bill_count" label="提单件数">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="bill_weight" label="提单重量">
              <InputNumber style={{ width: '100%' }} step={0.01} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="package_count" label="包裹数量">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default BasicInfoSection;
